import { useCallback, useState } from "react";

/**
 * Local, non-persisting Script text-size control. Mirrors the established
 * MissionAssist reader font-size contract (see
 * frontend/src/pages/script-play/hooks/useReaderFontSize.js — same bounds,
 * step, and floor) without any browser storage: this is presentation state
 * only for IP-008, reset on remount. The returned shape intentionally
 * matches that hook's so a persisted version could replace this
 * implementation later without changing how the Script surface consumes it.
 */
const MIN_DELTA = -4;
const MAX_DELTA = 8;
const STEP = 1;
const MIN_FONT_SIZE = 12;
const DEFAULT_BASE_FONT_SIZE = 16;

export function useScriptTextSize(baseFontSize = DEFAULT_BASE_FONT_SIZE) {
  const [fontDelta, setFontDelta] = useState(0);

  const increase = useCallback(() => {
    setFontDelta((delta) => Math.min(MAX_DELTA, delta + STEP));
  }, []);

  const decrease = useCallback(() => {
    setFontDelta((delta) => Math.max(MIN_DELTA, delta - STEP));
  }, []);

  return {
    fontSize: Math.max(MIN_FONT_SIZE, baseFontSize + fontDelta),
    fontDelta,
    increase,
    decrease,
    canIncrease: fontDelta < MAX_DELTA,
    canDecrease: fontDelta > MIN_DELTA,
  };
}

export default useScriptTextSize;
